const TIMEFRAMES = ["15m", "1H", "4H", "D", "W"];

export default function TimeframeSwitch({ value, onChange }) {
  return (
    <div className="inline-flex border border-neutral-800 bg-neutral-950" data-testid="timeframe-switch">
      {TIMEFRAMES.map((tf) => {
        const active = tf === value;
        return (
          <button
            key={tf}
            type="button"
            onClick={() => onChange(tf)}
            data-testid={`tf-${tf}`}
            className={`px-3 py-2 text-xs font-mono tabular-nums transition-colors ${
              active ? "bg-white text-black" : "text-neutral-400 hover:text-white"
            }`}
          >
            {tf}
          </button>
        );
      })}
    </div>
  );
}
